import { Requirements } from 'app/routes';

import { PayerDetail, setPayer, setPayerId } from 'store/models/payerDetail';

const PayerDetailRequirements: Requirements<{
    payerDetail: PayerDetail;
}> = {
    methods: ({ match }) => ({
        payerDetail: { url: `/api/v1/backoffice/payers/${match?.params.payerId || ''}`, cacheable: false },
    }),
    resolve: ({ result: { payerDetail }, match }) => [setPayer(payerDetail), setPayerId(match?.params.payerId || '')],
};

export default PayerDetailRequirements;
